import Vue from 'vue'
import PortalVue from 'portal-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Websockets from './plugins/Websockets'
import VueMask from 'v-mask'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.config.productionTip = false
Vue.use(PortalVue)
Vue.use(Websockets)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Vue.use(VueMask)
Vue.use(Vue2TouchEvents)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
